import $ from "jquery";
$(() => {
  activateFirstProductTab();
});
function activateFirstProductTab() {
  $(".product-tabs .nav .nav-item:first-child a").tab("show");
}
$(".js-product-name").each(function() {
  var text = $(this).text().replace("Re.sponsable", '<span class="responsable-wrapper"><span class="re"></span>sponsable</span>');
  $(this).html(text);
});
if ($(".guide_tailles").length) {
  $(".guide-tailles-container").removeClass("d-none");
}
$("#guide_tailles").on("click", function(e) {
  e.preventDefault();
  $([document.documentElement, document.body]).animate({
    scrollTop: $(".guide_tailles").offset().top - 200
  }, 1500);
});
$(".js-bfv-composition").on("click", function(e) {
  e.preventDefault();
  $([document.documentElement, document.body]).animate({
    scrollTop: $("#bfv_composition").offset().top - 100
  }, 1500);
});
document.addEventListener("DOMContentLoaded", function() {
  prestashop.on("updatedProduct", ({
    eventType
  }) => {
    $('.product-subscribe-form [name="purchase_type"]:is(:checked)').attr("checked", false);
    displayDeclinaisonsAlias();
  });
  function displayDeclinaisonsAlias() {
    let id_product = $("#product_page_product_id").val();
    if (jQuery.inArray(parseInt(id_product), [1925, 1927, 1929, 1930]) !== -1 && $("#group_19").length) {
      let label_declinaisons = $("#js-product-declinaison");
      label_declinaisons.removeClass("d-none");
      switch ($("#group_19 :selected").val()) {
        case "290":
          label_declinaisons.html("1 unit\xE9");
          break;
        case "289":
          label_declinaisons.html("2 unit\xE9s");
          break;
        default:
          label_declinaisons.addClass("d-none");
          break;
      }
    }
  }
  displayDeclinaisonsAlias();
});
if (module.hot) {
  module.hot.accept();
}
